import { biLoggerFactory } from 'wix-private';

const msid = '6b9c24c9-dcd3-433d-af01-1eeaaab66354'; //replace the value between quotes with your site msid value

/**
 * biGroupsLoggers it's an Object with key:value pair
 * key: represents src of the BI group
 * value: represents the biLogger function for that group
 * */

const biGroupsLoggers = {
    19: biLoggerFactory('logo-hp-new', 19, { msid }),
}

export async function fireBIEvent(src, evid, fields) {

    const biLogger = biGroupsLoggers[src];
    try {
        const biEventObject = {
            evid,
            ...fields
        };
        await biLogger.log(biEventObject);
        console.log('BI Event Fired Successfully with ', biEventObject);
    } catch (err) {
        console.error(`Failed to fireBIEvent -err- ${err}`);
    }
}